import React, { FC } from "react";
import clsx from "clsx";

import styles from "./RealizationButton.module.scss";

type Kind = "roots" | "will";
type Variant = "stock" | "convert";

type Props =
  | {
      kind: "roots";
      variant?: "stock";
      isDisabled?: boolean;
      onClick: () => void;
    }
  | {
      kind: "will";
      variant?: Variant;
      isDisabled?: boolean;
      onClick: () => void;
    };

const KIND_META: Record<
  Kind,
  {
    label: string;
    variant: Partial<Record<Variant, string>>;
  }
> = {
  roots: {
    label: "気づき",
    variant: {
      stock: "ROOTSを\nストック",
    },
  },
  will: {
    label: "意志",
    variant: {
      stock: "WILLを\nストック",
      convert: "WILL化",
    },
  },
};

const RealizationButton: FC<Props> = ({
  kind,
  variant = "stock",
  isDisabled,
  onClick,
}) => {
  return (
    <button
      className={clsx(styles.button, styles[kind])}
      disabled={isDisabled}
      onClick={onClick}
    >
      <span className={styles.label}>{KIND_META[kind].label}</span>
      <span className={styles.text}>{KIND_META[kind].variant[variant]}</span>
    </button>
  );
};

export default RealizationButton;
